// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  /* text-align: center; */
  font-family: 'Georgia', sans-serif;
}


.custom-scroll {
  overflow-y: auto;
}

/* Only this container */
.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #4d4d4d; /* green */
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB,EAAE,UAAU;EAC/B,kBAAkB;AACpB","sourcesContent":[".App {\r\n  /* text-align: center; */\r\n  font-family: 'Georgia', sans-serif;\r\n}\r\n\r\n\r\n.custom-scroll {\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Only this container */\r\n.custom-scroll::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.custom-scroll::-webkit-scrollbar-thumb {\r\n  background: #4d4d4d; /* green */\r\n  border-radius: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
